const ActivityDurations = [
    {
        label: "15 Minutes",
        value: 15,
        id: 15,
    },
    {
        label: "30 Minutes",
        value: 30,
        id: 30,
    },
    {
        label: "45 Minutes",
        value: 45,
        id: 45,
    },
    {
        label: "60 Minutes",
        value: 60,
        id: 60,
    },
    {
        label: "75 Minutes",
        value: 75,
        id: 75,
    },
    {
        label: "90 Minutes",
        value: 90,
        id: 90,
    },
    {
        label: "105 Minutes",
        value: 105,
        id: 105,
    },
    {
        label: "120 Minutes",
        value: 120,
        id: 120,
    },
]

export default ActivityDurations;
